<template>
<div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
        <div class="page-title">
            <h2>{{$t('drug.dRUGS')}}</h2>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="$router.push({ name: 'DrugRegister' })">
                {{$t('drug.registerAdrug')}}
            </v-btn>
        </div>
        <!-------------------------- Tablet Screens -------------------------->
        <!-- start -->
        <v-card v-if="$vuetify.breakpoint.width <= 980" elevation="0" class="px-5" :loading="loading" :class="loading ? '' : 'py-1'" flat>
            <div class="d-flex mt-5">
                <v-text-field prepend-inner-icon="mdi-magnify" outlined height="5px" :placeholder="$t('drug.sEARCH')" dense v-model="search" @click:append="searchDrugs" @input="resetSearchOnEmpty" class="shrink"></v-text-field>
                <v-btn :disabled="search.length < 1" color="primary" height="40" width="40" max-width="40" outlined class="ml-8" @click="searchDrugs">
                    <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                    {{ from }} - {{ to }} of {{ totaldrugs }}
                </div>
                <v-btn class="mx-2" fab small outlined color="primary" :disabled="tabletTableOptions.page <= 1" @click="tabletPageChange(false)">
                    <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn class="mx-2" fab small outlined color="primary" :disabled="tabletTableOptions.page >= totalPages" @click="tabletPageChange(true)">
                    <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
            </div>
            <v-card v-for="(item, index) in items" :key="item.departmentNumber" class="inner-card my-4 py-2 px-4" :elevation="0" :style="
            index % 2 !== 0 && {
              backgroundColor: 'rgba(243, 243, 243, 0.5)',
            }
          " @mouseover="selectItem(item)" @mouseleave="unSelectItem()" @click="goToDrug(item.drugNumber)">
                <v-card-text class="py-1" style="color: #00bd73">
                    {{ `#${item.drugNumber}` }}
                </v-card-text>
                <v-card-text>
                    {{ item.drugName }}
                </v-card-text>
                <v-row no-gutters class="my-5">
                    <v-col md="3">
                        <v-card-text style="color: #787878" class="py-1">{{$t('drug.genericName')}}</v-card-text>
                        <v-card-text class="py-1">{{
                `#${item.genericName}`
              }}</v-card-text>
                    </v-col>
                    <v-col md="3">
                        <v-card-text style="color: #787878" class="py-1">{{$t('drug.manufacturer')}}</v-card-text>
                        <v-card-text class="py-1">{{ item.manufacturer }}</v-card-text>
                    </v-col>
                    <v-col md="3">
                        <v-card-text style="color: #787878" class="py-1">{{$t('drug.distributor')}}</v-card-text>
                        <v-card-text class="py-1">{{ item.distributor }}</v-card-text>
                    </v-col>
                    <v-col md="3">
                        <v-card-text style="color: #787878" class="py-1">{{$t('drug.registrationDate')}}</v-card-text>
                        <v-card-text class="py-1">{{
                item.registrationDate
              }}</v-card-text>
                    </v-col>
                </v-row>
            </v-card>
        </v-card>
        <!------------------------ End -------------------------->
        <v-card flat v-else elevation="0" class="px-5">
            <v-card-text>
                <v-data-table 
                :headers="headers"
                :items="items" 
                item-key="drugNumber" 
                :items-per-page="10" 
                :loading="loading" 
                loading-text="Loading Drugs... Please wait" 
                :hide-default-footer="true" 
                :footer-props="{
                  'items-per-page-options': [5, 10, 25],
                  'show-first-last-page': true,
                  'show-current-page': true,
                  'items-per-page-text': 'Drugs per page',
                }" 
                :options.sync="tableOptions" 
                :server-items-length="totaldrugs" 
                :header-props="{
                  'sort-icon': 'mdi-unfold-more-horizontal'
                }"
              >
                    <template v-slot:top>
                        <div class="d-flex mt-5">
                            <v-text-field 
                              prepend-inner-icon="mdi-magnify" 
                              outlined height="5px" 
                              :placeholder="$t('drug.sEARCH')" 
                              dense 
                              v-model="search" 
                              @click:append="searchDrugs" 
                              @input="resetSearchOnEmpty" 
                              class="shrink"
                            ></v-text-field>
                            <v-btn :disabled="search.length < 1" color="primary" height="40" width="40" max-width="40" outlined class="ml-8" @click="searchDrugs">
                                <v-icon>mdi-filter-outline</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div class="py-1 title">
                                {{ from }} - {{ to }} of {{ totaldrugs }}
                            </div>
                            <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page <= 1" @click="pageChange(false)">
                                <v-icon dark> mdi-chevron-left </v-icon>
                            </v-btn>
                            <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page >= totalPages" @click="pageChange(true)">
                                <v-icon dark> mdi-chevron-right </v-icon>
                            </v-btn>
                        </div>
                    </template>
                    <template v-slot:progress>
                        <v-progress-linear color="primary" :height="6" indeterminate></v-progress-linear>
                    </template>
                    <template v-if="items.length > 0" v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.drugNumber" @mouseover="selectItem(item)" @mouseleave="unSelectItem()" @click="goToDrug(item.drugNumber)" style="position: relative; width: 0; height: 0">
                                <td>{{ item.drugNumber }}</td>
                                <td>{{ item.drugName }}</td>
                                <td>{{ item.genericName }}</td>
                                <td>{{ item.manufacturer }}</td>
                                <td>{{ item.distributor }}</td>
                                <td>{{ item.registrationDate | formatDate }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import DrugService from "@/_services/DrugService";

export default {
    components: {
        breadcrumb: Breadcrumb,
    },
    watch: {
        tableOptions: {
            handler() {
                this.getDrugData();
            },
            deep: true,
        },
    },
    created() {
        if (this.$vuetify.breakpoint.width <= 980) this.getTabletDrug();
    },
    async mounted() {
        document.title = this.$t('drug.dRUGS');
    },
    methods: {
        selectItem(item) {
            this.selectedItem = item;
        },
        unSelectItem() {
            this.selectedItem = false;
        },
        searchDrugs() {
            if (this.search == "") return;
            if (this.$vuetify.breakpoint.width <= 980) {
                this.tabletTableOptions.page = 1;
                this.getTabletDrug();
            } else {
                this.tableOptions.page = 1;
                this.getdrug();
            }
        },
        resetSearchOnEmpty() {
            // if (this.search === "") return;
            if (this.$vuetify.breakpoint.width <= 980) {
                this.tabletTableOptions.page = 1;
                this.getTabletDrug();
            } else {
                this.tableOptions.page = 1;
                this.getdrug();
            }
        },
        getDrugData() {
            this.getdrug();
            // console.log(sortBy, sortDesc) // shortBy = email, sortDesc true/false
        },
        getTabletDrug() {
            this.loading = true;
            DrugService.getDrugs(this.tabletTableOptions, this.search)
                .then((res) => {
                    if (res.success) {
                        this.items = res.data.drugInventory.rows;
                        this.currentrows = res.data.drugInventory.numRows;
                        this.totaldrugs = res.data.drugInventory.totalRows;
                        this.pageCount = Math.ceil(
                            this.totaldrugs / this.tabletTableOptions.itemsPerPage
                        );
                        this.totalPages = Math.ceil(
                            this.totaldrugs / this.tabletTableOptions.itemsPerPage
                        );
                        this.from =
                            (this.tabletTableOptions.page - 1) *
                            this.tabletTableOptions.itemsPerPage +
                            1;
                        this.to =
                            this.tabletTableOptions.page *
                            this.tabletTableOptions.itemsPerPage -
                            (this.tabletTableOptions.itemsPerPage -
                                res.data.drugInventory.numRows);
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
        },
        getdrug() {
            this.loading = true;
            DrugService.getDrugs(this.tableOptions, this.search)
                .then((res) => {
                    if (res.success) {
                        this.items = res.data.drugInventory.rows;
                        this.currentrows = res.data.drugInventory.numRows;
                        this.totaldrugs = res.data.drugInventory.totalRows;
                        this.pageCount = Math.ceil(
                            this.totaldrugs / this.tableOptions.itemsPerPage
                        );
                        this.totalPages = Math.ceil(
                            this.totaldrugs / this.tableOptions.itemsPerPage
                        );
                        this.from =
                            (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
                        this.to =
                            this.tableOptions.page * this.tableOptions.itemsPerPage -
                            (this.tableOptions.itemsPerPage - res.data.drugInventory.numRows);
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
        },
        deleteItem(id) {
            DrugService.deleteDrug(id)
                .then((res) => {
                    console.log("res", res);
                    if (res.success == true) {
                        this.items = this.items.filter((item) => {
                            return item.drugNumber != id;
                        });
                        this.currentrows = this.currentrows - 1;
                        this.totaldrugs = this.totaldrugs - 1;

                        this.$notify({
                            title: "Drug Deleted",
                            text: res.message,
                            type: "success",
                        });
                    } else {
                        this.$notify({
                            title: "Drug Not Deleted",
                            text: res.message,
                            type: "error",
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
        },
        pageChange(t) {
            if (t) this.tableOptions.page = this.tableOptions.page + 1;
            else this.tableOptions.page = this.tableOptions.page - 1;
            this.getfarm();
        },
        tabletPageChange(t) {
            if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
            else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
            this.getTabletDrug();
        },
        goToDrug(drgNum) {
            this.$router.push({
                name: "DrugInventory",
                params: {
                    id: drgNum
                }
            });
        },
    },
    data() {
        return {
            to: "",
            from: "",
            totalPages: "",
            transition: true,
            pageCount: 1,
            currentrows: 0,
            search: "",
            selected: [],
            items: [],
            totaldrugs: 1,
            selectedItem: false,
            tableOptions: {},
            tabletTableOptions: {
                itemsPerPage: 10,
                page: 1,
                sortBy: []
            },
            loading: false,
            // loadingText: "Loading... Please wait",
            breadcrumbs: [{
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t('drugInventory'),
                    disabled: true,
                    to: {
                        name: "My farm"
                    },
                },
            ],
            headers: [{
                    text: this.$t('drug.drugId'),
                    align: "start",
                    sortable: false,
                    class: "black--text",
                    value: "drugNumber",
                },
                {
                    text: this.$t('drug.drugName'),
                    value: "drugName",
                    class: "black--text"
                },
                {
                    text: this.$t('drug.drugGenericname'),
                    value: "genericName",
                    class: "black--text",
                },
                {
                    text: this.$t('drug.drugManufacturer'),
                    value: "manufacturer",
                    class: "black--text",
                },
                {
                    text: this.$t('drug.distributorName'),
                    value: "distributor",
                    class: "black--text",
                },
                {
                    text: this.$t('drug.drugRegistrationdate'),
                    value: "regDate",
                    class: "black--text",
                    sortable: false,
                },
            ],
        };
    },
    mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header {
    background: $secondary2-color;
}

::v-deep .v-data-table-header span {
    text-transform: uppercase !important;
    color: black;
}

.route {
    text-decoration: none !important;
}

::v-deep .v-data-table-header th {
    white-space: nowrap;
}

::v-deep .v-data-table-header__icon {
    display: inline-block;
    opacity: 100 !important;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
